<div class="file-explorer-summary-wrapper">
    <div class="file-explorer-summary-header">
        <p *ngIf="selectedFiles.length === 0">{{ 'noFilesSelected' | translate }}</p>
        <p *ngIf="selectedFiles.length > 0">({{ selectedFiles.length }}) {{ 'filesSelected' | translate }}</p>
    </div>
    <div
        class="scroll-wrapper"
        [style]="{ height: selectedFiles.length * 32 + 16 + 'px', maxHeight: 'calc(' + height + ' - 48px)' }"
        *ngIf="selectedFiles.length > 0"
    >
        <custom-scroll [style]="{ maxHeight: 'calc(' + height + ' - 48px)' }">
            <ul class="summary-list" *ngIf="selectedFiles.length > 0">
                <li class="summary-item" *ngFor="let file of selectedFiles">
                    <div class="item-content">
                        <i class="modus-icons" aria-hidden="true">file</i>
                        <div class="folder-name">
                            {{ file.name }}
                        </div>
                    </div>
                    <gsp-button
                        iconClass="modus-icons"
                        modusIcon="close"
                        [type]="ButtonType.Icon"
                        (action)="deselectFile(file)"
                    >
                    </gsp-button>
                </li>
            </ul>
        </custom-scroll>
    </div>
</div>
